import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Modal,
  Grid,
  Stack,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import EventIcon from "@mui/icons-material/Event";

import Swal from "sweetalert2";

import {
  convertDateFormat,
  convertDateToCustomFormat,
  swalAlertPopProps,
} from "../../utils/commonUtils";
import { addExpense, updateExpense } from "./expanceApi";
import ExpenseModalCard from "./expenseModalCard";
import { addData, updateBill } from "./expenseCustomApiHandlers";
import { validationsAdd, validationsSave } from "./expenceValidationFunction";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { totalPrice } from "../purchase/purFunction";
import { totalPriceExpense } from "./expenseFunction";
import { ModalHeader } from "../../common/modalHeader";
import dayjs from "dayjs";

export default function ExpenseModal({
  open,
  setOpen,
  getexpence,
  filterByProp,
  getPurchase,
  listChategory,
  idProp,
  expenseItemArrProps,
  updateModalData,
}) {
  //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [search, setSearch] = useState("");

  const data = {
    customerMobile: "",
  };
  const [billData, setBillData] = useState(data);

  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const [searchItem, setSearchItem] = useState([]);

  let payload = {
    amount: 0,
    description: "",
  };
  const [ExpenseItems, setExpenseItems] = useState(payload);

  const stockPayload = {
    page: 1,
    pageSize: 10,
  };

  const [ExpenseItemssArr, setExpenseItemssArr] = useState([]);
  const [id, setId] = useState();
  const [pagination, setPagination] = useState({
    page: 1,
    total: 10,
    records: 0,
  });

  useEffect(() => {
    if (open === true) {
      if (filterByProp) {
        setFilterBy(filterByProp);
        setExpenseItemssArr(expenseItemArrProps);
        setId(idProp);
        setDate(updateModalData?.date ? dayjs(updateModalData.date) : dayjs());
      } else {
        setDate(dayjs());
      }
    } else {
      console.log("close");
      setExpenseItems(payload);
      setFilterBy(filters[0].value);
      setExpenseItemssArr([]);
      setId();
      setDate(null); 
      // setExpenseItemssArr([]);
    }
  }, [open]);
  const addLeadingZero = (value) => {
    return value < 10 ? "0" + value : value;
  };
   const [date, setDate] = useState(dayjs());
  const [dateOpen, setDateOpen] = useState(false);

  useEffect(() => {
    console.log("updateModalData====", updateModalData);
  }, [updateModalData]);

  useEffect(() => {}, [filterByProp]);
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD")); // formatted for API or DB
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const [filters, setFilters] = useState([
    {
      name: "Raw Material",
      value: "Raw material",
    },
    { name: "Salary", value: "Salary" },
    {
      name: "Shop Maintenance",
      value: "Shop Maintenance",
    },
    { name: "Other", value: "Other" },
  ]);
  const [filterBy, setFilterBy] = useState(null);
  // const addData = async () => {};
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "100%", sm: "80%", md: "65%", lg: "52%" }, // Responsive width
          maxHeight: "90vh", // Prevent vertical overflow
          overflowY: "auto",
          position: "absolute",
          borderRadius: "10px",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)", // Perfect center alignment
          boxShadow: 24,
          p: 2,
        }}
      >
        <ModalHeader
          title={"Expenses"}
          onClose={(data) => {
            setOpen(data);
          }}
        />

        <Grid container sx={{ position: "relative" }}>
          {/* <Grid item xs={12} sm={6} sx={{ p: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mt: 2 }}
            >
              <Typography color="primary">
                <strong>Total Items: &nbsp;</strong>
              </Typography>
              <Pagination
                count={pagination.total}
                page={pagination.page}
                onChange={handleChange}
              />
            </Stack>
          </Grid> */}
          <Grid item xs={12} sx={{ borderRight: "1px solid #dfdfdf" }}>
            <DialogContent
              sx={{ padding: "10px 20px", borderBottom: "2px solid #01008B" }}
            >
              <Grid container spacing={{ sm: 2, xs: 1 }}>
                {/* Date Input */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ mt: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={dateOpen}
                        InputLabelProps={{
                          className: "mulish",
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                        onOpen={() => setDateOpen(true)}
                        onClose={() => setDateOpen(false)}
                        value={
                          dayjs.isDayjs(date) ? date : date ? dayjs(date) : null
                        }
                        onChange={(val) => {
                          setDate(val);
                          setDateOpen(false);
                        }}
                        maxDate={dayjs()}
                        format="DD-MM-YYYY"
                        slotProps={{
                          textField: {
                            label: "Date",
                            InputLabelProps: { shrink: !!date },
                            InputProps: {
                              readOnly: true,
                              endAdornment: (
                                <CalendarMonthIcon
                                  sx={{
                                    cursor: "pointer",
                                    mr: 1,
                                    color: "black",
                                  }}
                                  onClick={() => setDateOpen(true)}
                                />
                              ),
                              sx: {
                                background: "#fff",
                                borderRadius: 1,
                                cursor: "pointer",
                                fontFamily: "'Montserrat', sans-serif",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              },
                            },
                            value: date,
                            id: "datepickerfield",
                            placeholder: "Select date",
                            fullWidth: true,
                            size: "small",
                            onClick: () => setDateOpen(true),
                            sx: { width: "100%", m: 0 },
                          },
                          popper: {
                            sx: { zIndex: 2000 },
                          },
                        }}
                        // slotProps={{
                        //   textField: {
                        //     label: "Date",
                        //     InputLabelProps: { shrink: true },
                        //     value: date ? dayjs(date).format("DD-MM-YYYY") : "",
                        //     id: "datepickerfield",
                        //     placeholder: "Select date",
                        //     fullWidth: true,
                        //     size: "small",
                        //     sx: { width: "100%", height: "50px", m: 0 },
                        //   },
                        // }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ mt: { sm: 1, xs: 0 }, cursor: "pointer" }}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        sx={{
                          position: "absolute",
                          top: "0",
                          height: { xs: "35px", sm: "36px", md: "38px" },
                        }}
                      >
                        Select Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={filterBy}
                        label="Select Category"
                        onChange={(e) => {
                          setFilterBy(e.target.value);
                        }}
                        sx={{
                          height: { xs: "35px", sm: "36px", md: "38px" },
                        }}
                        InputProps={{
                          sx: {
                            height: { xs: "35px", sm: "36px", md: "38px" },

                            // background:"yellow"
                          },
                        }}
                      >
                        {listChategory.map((item, index) => {
                          return (
                            <MenuItem value={item.name} key={"option" + index}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{}}>
                    <TextField
                      fullWidth
                      size="small"
                      autoComplete="off"
                      type="text"
                      id="name"
                      label="Description of Expenses"
                      value={ExpenseItems?.description}
                      onChange={(e) => {
                        // getUnpaid({
                        //   customerMobile: e.target.value,
                        // });
                        setExpenseItems({
                          ...ExpenseItems,
                          description: e.target.value,
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        style: {
                          // height: '40px',
                          // background:"yellow"
                        },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{}}>
                    <TextField
                      fullWidth
                      id="briefAddress"
                      size="small"
                      label="Amount"
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        style: {
                          // height: '40px',
                          // background:"yellow"
                        },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      value={
                        ExpenseItems?.amount !== 0 ? ExpenseItems?.amount : ""
                      }
                      onChange={(e) => {
                        let val = e.target.value;
                        val = val.replace(/\D/g, "");
                        setExpenseItems({
                          ...ExpenseItems,
                          amount: val > 0 ? Number(val) : "",
                        });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "end" }}
                >
                  <DialogActions>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setExpenseItemssArr([]);
                      }}
                      sx={{
                        paddingX: "50px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        const valid = validationsAdd(ExpenseItems);
                        if (valid.status) {
                          setExpenseItemssArr([
                            ...ExpenseItemssArr,
                            {
                              ...ExpenseItems,
                            },
                          ]);

                          setExpenseItems(payload);
                        } else {
                          Swal.fire({
                            text: valid?.msg,
                            icon: "warning",

                            ...swalAlertPopProps,
                          });
                          setOpen(false);
                        }
                      }}
                      sx={{
                        paddingX: "50px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Add
                    </Button>
                  </DialogActions>
                </Grid>
              </Grid>
            </DialogContent>
          </Grid>
          <Grid
            item
            sm={12}
            sx={{
              justifyContent: "space-between",
              flexDirection: "row-reverse",
              width: "100%",
            }}
          >
            <Typography
              component="p"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Description of Expenses
              </Typography>
              <Typography
                component="span"
                sx={{
                  marginRight: "50px",
                  color: "#01008B",
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Amount
              </Typography>
            </Typography>
            <Grid
              container
              sx={{
                height: ExpenseItemssArr?.length < 3 ? "10vh" : "20vh",
                overflowY: "auto",
                paddingX: "20px",
              }}
            >
              {ExpenseItemssArr?.map((item, index) => {
                return (
                  <Grid item xs={12} key={index + "expense"}>
                    <ExpenseModalCard
                      index={index}
                      item={item}
                      ExpenseItemssArr={ExpenseItemssArr}
                      setExpenseItemssArr={setExpenseItemssArr}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingX: "30px",
                  paddingTop: "10px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: { xs: "14px", sm: "14px", md: "15px" },
                  }}
                >
                  Total Amount: &nbsp;
                </Typography>
                <Box
                  component="span"
                  sx={{
                    fontWeight: 600,
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: { xs: "14px", sm: "14px", md: "18px" },
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "25px",
                  }}
                >
                  {" "}
                  <CurrencyRupeeIcon sx={{ fontSize: "18px" }} />
                  {totalPriceExpense(ExpenseItemssArr)}
                </Box>
              </Box>
            </Box>
            <Divider
              sx={{
                background: (theme) => theme.palette.primary.main,
                width: "100%",
                mt: 2,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                sx={{ width: "70%" }}
                onClick={() => {
                  setOpen(false);
                  const valid = validationsSave(ExpenseItemssArr);
                  if (valid.status) {
                    id
                      ? updateBill(
                          {
                            id: id,
                            date: date.format("YYYY-MM-DD"),
                            category: filterBy,
                            expenseDetails: ExpenseItemssArr,
                          },
                          updateExpense,
                          Swal,
                          getPurchase
                        )
                      : addData(
                          {
                            date: date.format("YYYY-MM-DD"),
                            category: filterBy,
                            expenseDetails: ExpenseItemssArr,
                          },
                          addExpense,
                          Swal,
                          getPurchase
                        );
                  } else {
                    Swal.fire({
                      text: valid.msg,
                      icon: "warning",
                      ...swalAlertPopProps,
                    });
                  }
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
